<template>
  <div>
    <!-- 云文件上传对话框 -->
    <cargo-cloud-file-upload
      :visible.sync="cloudFile.visible"
      :job="cloudFile.job"
      :upload-source="UPLOAD_SOURCE_FILE_HISTORY.code"
      :lob="cloudFile.lob"
      :job-uuids="cloudFile.jobUuids"
      :upload-to-job-uuids-sync="true"
      :tenant-instruction-uuid="tenantInstruction.uuid"
      :file-category="cloudFile.fileCategory"
      :file-category-label="cloudFile.fileCategoryLabel"
      :can-change-file-category="false"
      @uploadSuccess="instructionCallBackByUploadFile"
    />
  </div>
</template>

<script>
import cargoCloudFileUpload from '@/components/Cargo/Common/cargoCloudFileUpload'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { Job } from '@/class/model/booking/Job'
import { batchUpdateTrackingForDocumentType } from '@/api/fileHistory'

export default {
  name: 'UpoloadFileWindow',
  components: { cargoCloudFileUpload },
  data() {
    return {
      UPLOAD_SOURCE_FILE_HISTORY: SystemConstants.UPLOAD_SOURCE_FILE_HISTORY,
      isSop: false,
      tenantInstruction: {
        uuid: '',
        platformInstructionCode: '',
        allowMultipleOperations: false
      },
      fileCategoryUuid: '',
      cloudFile: {
        visible: false,
        job: new Job(),
        lob: 'SE',
        jobUuids: [],
        fileCategory: '',
        fileCategoryLabel: ''
      }
    }
  },
  methods: {
    // UI自定义使用
    onShowOfUI(uiInstruction, job) {
      this.isSop = false
      this.tenantInstruction.uuid = uiInstruction.tenantInstructionUuid
      this.tenantInstruction.platformInstructionCode = uiInstruction.platformInstructionRuleCode
      this.tenantInstruction.allowMultipleOperations = uiInstruction.allowMultipleOperations || false
      if (uiInstruction.instructionRuleJson) {
        this.fileCategoryUuid = uiInstruction.instructionRuleJson.fileCategoryUuid || ''
        this.cloudFile.fileCategory = uiInstruction.instructionRuleJson.fileCategory || ''
        this.cloudFile.fileCategoryLabel = uiInstruction.instructionRuleJson.fileCategoryLabel || ''
      } else {
        this.fileCategoryUuid = ''
        this.cloudFile.fileCategory = ''
        this.cloudFile.fileCategoryLabel = ''
      }
      this.cloudFile.job = new Job(job)
      this.cloudFile.lob = job.lob
      this.cloudFile.jobUuids = []
      this.cloudFile.visible = true
    },
    // SOP面板使用
    onShowOfSOP(sopInstruction, jobs) {
      this.isSop = true
      this.tenantInstruction.uuid = sopInstruction.uuid
      this.tenantInstruction.platformInstructionCode = sopInstruction.platformInstructionCode
      this.tenantInstruction.allowMultipleOperations = sopInstruction.allowMultipleOperations || false
      if (sopInstruction.instructionRuleJson) {
        this.fileCategoryUuid = sopInstruction.instructionRuleJson.fileCategoryUuid || ''
        this.cloudFile.fileCategory = sopInstruction.instructionRuleJson.fileCategory || ''
        this.cloudFile.fileCategoryLabel = sopInstruction.instructionRuleJson.fileCategoryLabel || ''
      } else {
        this.fileCategoryUuid = ''
        this.cloudFile.fileCategory = ''
        this.cloudFile.fileCategoryLabel = ''
      }
      this.cloudFile.job = new Job(jobs[0])
      this.cloudFile.lob = jobs[0].lob
      this.cloudFile.jobUuids = jobs.filter(p => p.uuid !== this.cloudFile.job.uuid).map(p => p.uuid)
      this.cloudFile.visible = true
    },
    // 【文件上传】指令 回调（不需要生成）
    instructionCallBackByUploadFile() {
      if (this.fileCategoryUuid) {
        const jobDocKeysObj = {}
        jobDocKeysObj[this.cloudFile.job.uuid] = this.fileCategoryUuid
        if (this.cloudFile.jobUuids && this.cloudFile.jobUuids.length > 0) {
          this.cloudFile.jobUuids.forEach(jobUuid => {
            jobDocKeysObj[jobUuid] = this.fileCategoryUuid
          })
        }
        batchUpdateTrackingForDocumentType(jobDocKeysObj)
      }
      this.$emit('instructionCallback')
    }
  }
}
</script>
